document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu?.toggleAttribute('hidden', open);
      document.body.classList.toggle('menu-open', !open);
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const button = form?.querySelector('[data-add-to-cart]');
      const price = form?.closest('[data-product-info]')?.querySelector('[data-product-price]');
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});
